<template>
  <v-container fluid>
    <PageHeaderSlot>
      <template slot="top-right-slot" v-if="canCreate">
        <FormButton text="createCategory" isAdd class="ml-2" :to="{ name: 'CreateProductCategory' }" />
      </template>
    </PageHeaderSlot>

    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      :itemTotal="tableItemTotal"
      @options-update="getProductCategoryData()"
      actionViewRouteLink="ProductCategoryDetails"
      @delete-clicked="handleDelete($event)"
    />
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'

export default {
  name: 'ProductCategoryList',
  inject: ['getConfirmDialogRef'],
  components: {
    Datatable,
  },
  computed: {
    tableHeaders() {
      const vm = this
      let headers = [{ value: 'category_name', text: vm.$t('categoryName') }]
      if (this.$validate.allowAction('ProductCategoryDetails', this.userType)) {
        headers.push({ value: 'actionViewAndDelete', text: '' })
      }
      return headers
    },
    // permission / setting
    canCreate() {
      return this.$validate.allowAction('CreateProductCategory', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
  }),
  methods: {
    async getProductCategoryData(regenUrl = true) {
      if (regenUrl === true) {
        this._regenerateURL()
      }

      this.tableLoading = true
      try {
        let payload = {
          filter_limit: this.tableFilter.limit,
          filter_page: this.tableFilter.page - 1,
        }

        const { data, total } = await this.$Fetcher.GetProductCategories(payload)
        this.tableData = data.map(el => {
          return {
            id: el.id,
            category_name: el.name,
          }
        })

        this.tableItemTotal = total
      } catch (err) {
        this.tableData = []
        if (this.tableFilter.page === 1) {
          this.tableItemTotal = 0
        }
      } finally {
        this.tableLoading = false
      }
    },

    _getQuery() {
      this.tableFilter.page = 1
      this.tableFilter.limit = 10
      const query = this.gfGetTableQuery({
        page: 'int',
        limit: 'int',
      })
      for (const key in this.tableFilter) {
        if (this.$validate.DataValid(query[key])) {
          this.$set(this.tableFilter, key, query[key])
        }
      }
    },
    _regenerateURL() {
      let q = {
        page: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        limit: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) this.$router.replace({ query: newQuery })
    },

    // -- (刪除)
    async handleDelete(id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.$store.dispatch('setLoading', true)
      // check if category has product
      let confirmObj = {}
      const hasProduct = await this.checkCategoryHaveProduct(id)
      if (hasProduct) {
        confirmObj = {
          title: 'message.confirmToDeleteItem',
          message: 'message.confirmDeleteProductCategory',
        }
      } else {
        confirmObj = { isDelete: true }
      }
      this.$store.dispatch('setLoading', false)

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show(confirmObj)
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteProductCategory(id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
          })
          this.tableFilter.page = 1
          this.getProductCategoryData()
        } catch (err) {
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },
    async checkCategoryHaveProduct(id) {
      try {
        const { data } = await this.$Fetcher.GetProducts({
          filter_limit: 1,
          filter_page: 0,
          filter_item: [{ key: 'category', value: id }],
        })
        if (data[0].category_id === id) {
          return true
        }
      } catch {}
      return false
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: ProductCategoryList')
      this.userType = this.gfGetUserType()
      this.$store.dispatch('toggleLoadingPage', false)
      this._getQuery()
      await this.getProductCategoryData(false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>
